/** Formatting helpers shared by the Tax & GST view. Matches the app's
 *  house pattern of local Intl.NumberFormat('en-AU') helpers. */

const AUD2 = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const AUD0 = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/** $1,234.56 */
export function formatCurrency(n: number): string {
  return AUD2.format(Number(n) || 0);
}

/** $1,235 — for big headline figures where cents are noise. */
export function formatCurrency0(n: number): string {
  return AUD0.format(Number(n) || 0);
}

/** 0.3 → "30.0%" */
export function formatPct(frac: number): string {
  return `${((Number(frac) || 0) * 100).toFixed(1)}%`;
}
